import React, { useState, useEffect } from 'react';
import { IoIosArrowUp, IoIosArrowDown, IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { useChanges } from "../../../../hooks/useChanges";
import {useAdvanceChanges} from '../../../../hooks/useAdvanceChanges'
import './statusTamplate.scss'

const CounterTemplate = ({ data, keyName, keyTime, valueTitle, valueTime, timeType, advance }) => {
    const { addChangeToStore } = useChanges();
    const { addAdvanceChangeToStore } = useAdvanceChanges();
    const [counterWebhookFre, setCounterWebhookFre] = useState(data?.data && data?.data[keyName] ? data?.data[keyName] : 5);
    const dayTimeOptions = ['days', 'week', 'months', 'year'];
    const minTimeOptions = ['sec', 'min', 'hour'];
    const [timeOptions, setTimeOptions] = useState([]);
    const [selectedTimeIndex, setSelectedTimeIndex] = useState(0);
    const [currentTime, setCurrentTime] = useState(data?.data && data?.data[keyTime] ? data?.data[keyTime] : timeOptions[selectedTimeIndex]);

    useEffect(() => {
        if (timeType === 'day') {
            setTimeOptions(dayTimeOptions);
            setSelectedTimeIndex(dayTimeOptions.indexOf('day'));
        } else if (timeType === 'min') {
            setTimeOptions(minTimeOptions);
            setSelectedTimeIndex(minTimeOptions.indexOf('min'));
        }
    }, [timeType]);

    const incrementTime = () => {
        const newIndex = (selectedTimeIndex + 1) % timeOptions.length;
        setSelectedTimeIndex(newIndex);
        const newTime = timeOptions[newIndex];
        setCurrentTime(newTime);
        advance ? addAdvanceChangeToStore({ key: keyTime, value: newTime }) : addChangeToStore({ key: keyTime, value: newTime })
    
    };

    const decrementTime = () => {
        const newIndex = selectedTimeIndex === 0 ? timeOptions.length - 1 : selectedTimeIndex - 1;
        setSelectedTimeIndex(newIndex);
        const newTime = timeOptions[newIndex];
        setCurrentTime(newTime);
        advance ? addAdvanceChangeToStore({ key: keyTime, value: newTime }) : addChangeToStore({ key: keyTime, value: newTime })
    };
    
    const quantityCreationHandler = (currentValue) => {
        advance ? addAdvanceChangeToStore({ key: keyName, value: currentValue }) : addChangeToStore({ key: keyName, value: currentValue })
    }

    const incrementCounter = () => {
        const newValue = counterWebhookFre + 1;
        setCounterWebhookFre(newValue); 
        quantityCreationHandler(newValue);
    }

const decrementCounter = () => {
    const newValue = counterWebhookFre - 1;
    setCounterWebhookFre(newValue); 
    quantityCreationHandler(newValue);
}

    return (
        <div className='white_list_block_item_arr_user_wrap status_block_item_counter_wrap'>
            <div className='status_block_item_counter'>
                <div className='status_block_item_counter_webhook'>
                    <button onClick={incrementCounter}><IoIosArrowUp /></button>
                    <button onClick={decrementCounter}><IoIosArrowDown /></button>
                    <input type="text" value={counterWebhookFre} onChange={(e) => setCounterWebhookFre(e.target.value)} />
                    <p> {valueTitle ? valueTitle : ''}</p>
                </div>
                <div className='status_block_item_counter_min'>
                    <button onClick={decrementTime}><IoIosArrowBack /></button>
                    <p>{currentTime}</p>
                    
                    <button onClick={incrementTime}><IoIosArrowForward /></button>
                </div>
            </div>
        </div>
    );
};

export default CounterTemplate;
